import { render, staticRenderFns } from "./FolderShareDialog.vue?vue&type=template&id=515b42e9"
import script from "./FolderShareDialog.vue?vue&type=script&lang=js"
export * from "./FolderShareDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderShareDialog.vue?vue&type=style&index=0&id=515b42e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports